import { Component, OnInit,Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import * as _ from "underscore";
import { OfficeFilter } from '../../../shared/classes/filter';
import { SortBy } from '../../../Enums/sortEnums';
import { OfficesService } from '../../../shared/services/offices.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-offices-filter',
  templateUrl: './offices-filter.component.html',
  styleUrls: ['./offices-filter.component.less']
})
export class OfficesFilterComponent implements OnInit,OnDestroy {


  @Input() column;

  @Output() gridFiltersApplied = new EventEmitter();

  @Input() cityArray;

  filteredData : any;

  @Input() tableSettings;

  @Input() statusArray;
  private unsubscribe$ =new Subject<void>();


  selectAllCityType: {isChecked: boolean} = {isChecked : true};
  selectAllStatusType: {isChecked: boolean} = {isChecked : true};


  isUnSelectAll: boolean = false;
  
  constructor(private officesService : OfficesService) { }

  ngOnInit() {

    this.officesService.resetFilters
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {   
         
      this.resetFilters();
      
      this.officesService.resetHeaders.next();          
    });

    this.checkSelectAllFilter();
    this.checkFilterValue();
  }


  selectAllCityTypeFilter(check) {
    if (check) {
      this.cityArray.forEach(item => {
        item.isCheck = true;
      })
      // _.each(this.cityArray, function (item) {

      //   item.isCheck = true;
      // })
    }
    else {
      this.cityArray.forEach(item => {
        item.isCheck = false;
      })
      // _.each(this.cityArray, function (item) {

      //   item.isCheck = false;
      // })
    }
  }

  selectAllStatusFilter(check) {
    if (check) {
      this.statusArray.forEach(item => {
        item.isCheck = true;
      })

      // _.each(this.statusArray, function (item) {

      //   item.isCheck = true;
      // })
    }
    else {
      this.statusArray.forEach(item => {
        item.isCheck = false;
      })
      // _.each(this.statusArray, function (item) {

      //   item.isCheck = false;
      // })
    }
  }



  checkFilterValue(){

    if(OfficeFilter.cityList.length == 0 && OfficeFilter.cityList.indexOf('None') < 0){
      
      this.selectAllCityTypeFilter(true);
    }
    if(OfficeFilter.statusList.length==0 && OfficeFilter.statusList.indexOf('None')<0){
        this.selectAllStatusFilter(true);
    }
  }

  


  checkSelectAllFilter(){
    
    if(OfficeFilter.cityList.length >0 || OfficeFilter.cityList.indexOf('None') > -1){
  
      this.selectAllCityType.isChecked = false;
    }
    if(OfficeFilter.statusList.length >0 || OfficeFilter.statusList.indexOf('None') > -1){
  
      this.selectAllStatusType.isChecked = false;
    }
     
  }

      // Selection/unselection of filter options
  togglefilter(arrayType,selectAllValue,checked){
    
        var allTypeCount = arrayType.length;
        var checkedTypeCount = 0;
        arrayType.forEach(item => {
          if (item.isCheck) {              
            checkedTypeCount = checkedTypeCount + 1;
          }
        })

          // _.each(arrayType,function(item){
          //   if (item.isCheck) {
              
          //     checkedTypeCount = checkedTypeCount + 1;
          //   }
          // })
                  
        if(!checked){
          
            selectAllValue.isChecked = false;
        }
        else{
          if(allTypeCount == checkedTypeCount){
            selectAllValue.isChecked = true;
          }
          else{
            selectAllValue.isChecked = false;
          }
        }
  }

  checkSelectedCityType(arrayList,column){
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {

        selectedType.push(item.name);

      }
    })

    // _.each(arrayList, function(item){
    //     if (item.isCheck) {

    //             selectedType.push(item.name);

    //   }
    // })


      if(selectedType.length == arrayList.length){
        OfficeFilter.cityList = [];
          //column.isFilterIcon = false;
          // if(this.ContactMelater.isChecked){
          //   column.isFilterIcon = true;
          // }
      }
      else{
        return OfficeFilter.cityList = selectedType;
      }
    
  }

  // checkSelectedRoleType(arrayList,column){
  //   
  //   let selectedType =[];
  //   column.isFilterIcon = true;
  //   _.each(arrayList, function(item){
  //       if (item.isCheck) {

  //               selectedType.push(item.name);

  //     }
  //   })


  //     if(selectedType.length == arrayList.length){
  //       OfficeFilter.roleList = [];
  //         column.isFilterIcon = false;
  //         // if(this.ContactMelater.isChecked){
  //         //   column.isFilterIcon = true;
  //         // }
  //     }
  //     else{
  //       return OfficeFilter.roleList = selectedType;
  //     }
    
  // }
  checkSelectedStatusType(arrayList,column){
    
    let selectedType =[];
    column.isFilterIcon = true;
    arrayList.forEach(item => {
      if (item.isCheck) {            
        selectedType.push(item.name);            
}
    })
    // _.each(arrayList, function(item){
    //     if (item.isCheck) {            
    //             selectedType.push(item.name);            
    //   }
    // })
    
      if(selectedType.length == arrayList.length){
        OfficeFilter.statusList = [];
          //column.isFilterIcon = false;          
      }
      else{
        return OfficeFilter.statusList = selectedType;
      }
    
  }
  

  onFilterApply(column){

    this.isUnSelectAll = false;

    if(column.isResNameSortA) {
      column.sortOrder = 'Asc';
      
    }else if (column.isResNameSortD) {
      column.sortOrder = 'Desc';

    }else if (column.isResNameSortN) {
      column.sortOrder = '';
    
    }

    column.displaysort = false;
   
    if(column.sortBy == SortBy.City){          
      this.checkSelectedCityType(this.cityArray,column);
    }
    if(column.sortBy == SortBy.Status){          
      this.checkSelectedStatusType(this.statusArray,column);
    }       
    if(!this.isUnSelectAll){
    column.isFilterApplied = true;
  
    this.gridFiltersApplied.emit(true);
    }

  }


  // resetEvents(column){

   
 
  //   if(column.sortBy == SortBy.City){
  //     this.selectAllCityTypeFilter(true);
  //     this.selectAllCityType.isChecked = true;          
  //   }
   
 
  // }


  resetEvents(){
    this.tableSettings.columns.forEach(item => {
      item.displaysort = false;
    })

  //   _.each(this.tableSettings.columns, function (item) {
  //     item.displaysort = false;
  // })
}

  resetFilters()
  {        
    this.selectAllCityTypeFilter(true);
    this.selectAllCityType.isChecked = true;   
    this.selectAllStatusFilter(true);
    this.selectAllStatusType.isChecked = true; 
  }
  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
